import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';
import { BUSINESS_CONCEPT } from '@/constants/preAssessment';

const cyPrefix = 'containers_business_concept_container';

let ids = {
  BTN_BACK: 'BTN_BACK',
  BTN_SUBMIT: 'BTN_SUBMIT',
};
ids = addCyPrefixToIDs(cyPrefix, ids);

export const CY_BUSINESS_CONCEPT_CONTAINER_IDS = ids;

let businessConceptOptionIDs = BUSINESS_CONCEPT;
businessConceptOptionIDs = addCyPrefixToIDs(cyPrefix, businessConceptOptionIDs);

export const CY_BUSINESS_CONCEPT_OPTION_IDS = businessConceptOptionIDs;

export const tPrefix = 'products-fe.containers.business_concepts';
